import { put, call } from 'redux-saga/effects';
import { walletPaymentCreateAPI, walletPaymentSearchAPI, walletPaymentUpdateAPI, walletPaymentBulkUpdateTransactionsAPI } from 'src/api/WalletApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { WALLET_ACTIONS } from '../actions/WalletActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(walletPaymentSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });
        yield put({
            type: WALLET_ACTIONS.WALLET_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: WALLET_ACTIONS.WALLET_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({ _id }) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(walletPaymentSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });
        if (!data || !data[0]) {
            yield put(headerShowAction({
                data: 'Unable to Edit, something went wrong',
            }));
        }

        yield put({
            type: WALLET_ACTIONS.WALLET_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    
    try {
        const {
            data: {
                data,
            },
        } = yield call(walletPaymentCreateAPI, {
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Created',
        }));

        yield put({
            type: WALLET_ACTIONS.WALLET_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
    }
    catch (error) {
        console.error('LOG: insert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: WALLET_ACTIONS.WALLET_UPSERT_ERROR,
        });
    }
}

function* update(walletId, payload) {
    try {
        
        yield call(walletPaymentUpdateAPI, {
            walletId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));

        yield edit({ _id: walletId });
    }
    catch (error) {
        console.error('LOG: update error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: WALLET_ACTIONS.WALLET_UPSERT_ERROR,
        });
    }
}

function* bulkUpdateTransactions({ payload }) {
    try {
        yield call(walletPaymentBulkUpdateTransactionsAPI, payload);

        yield put(headerShowAction({
            data: 'Transactions Updated',
        }));

        yield put({
            type: WALLET_ACTIONS.WALLET_BULK_UPDATE_SUCCESS,
        });
    }
    catch (error) {
        console.error('LOG: bulk update error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: WALLET_ACTIONS.WALLET_BULK_UPDATE_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(WALLET_ACTIONS.WALLET_SEARCH, search),
    takeFirstSagaUtil(WALLET_ACTIONS.WALLET_UPSERT, upsert),
    takeFirstSagaUtil(WALLET_ACTIONS.WALLET_EDIT, edit),
    takeFirstSagaUtil(WALLET_ACTIONS.WALLET_BULK_UPDATE_TRANSACTIONS, bulkUpdateTransactions),
];
